const sum = (array: number[]) =>
  array.reduce(function (a, b) {
    return a + b;
  }, 0);

export default sum;
